export default {
  manage_equipment: "Equipamientos",
  manage_equipmentsTable_equipmentName: "Equipamiento del vehículo",
  manage_equipmentsTable_assignments: "Tareas",
  manage_equipmentsTable_search_by_equipment_name: "Buscar por Nombre de Vehículo"
};
